<template>
    <div>
        <h4 class="text-muted">{{$t('message.settings.message.redefinePassword')}}</h4>
        <v-text-field :label="$t('message.settings.message.currentPassword')"
                      type="password"
                      name="Senha atual"
                      v-model="val.atual"
                      v-validate="'required'"
                      @input="$emit('input', val)"></v-text-field>
        <v-text-field :label="$t('message.settings.message.newPassword')"
                      type="password"
                      name="Nova senha"
                      v-model="val.nova"
                      v-validate="'required'"
                      @input="$emit('input', val)"></v-text-field>
        <v-text-field :label="$t('message.settings.message.confirmNewPassword')"
                      type="password"
                      name="Confirmar nova senha"
                      v-model="val.confirmacao"
                      v-validate="'required'"
                      @input="$emit('input', val)"></v-text-field>

    </div>
</template>

<script>
    import vModel from '@mixins/v-model'
    import EventBus from '@packages/event-bus'

    export default {
        methods: {
            async validate() {
                let errors;
                if (!this.val.atual)
                    errors = this.$t('message.errorMessages.message.enterCurrentPassword')

                else if (!this.val.nova)
                    errors = this.$t('message.errorMessages.message.enterNewPassword')

                else if (!this.val.confirmacao)
                    errors = this.$t('message.errorMessages.message.confirmNewPassword')

                else if (this.val.nova && this.val.confirmacao){
                    if (this.val.nova !== this.val.confirmacao)
                        errors = this.$t('message.errorMessages.message.passwordsDontMatch')
                }

                if (errors){
                    EventBus.$emit('show-message', {
                        type: 'ERROR',
                        message: errors
                    })
                    return;
                }
                this.$emit('valid')
            },
        },

        mixins: [vModel],

    }
</script>

<style lang="scss" scoped>

</style>
